import React from "react";
import { useNavigate } from "react-router-dom";
import { Image } from "@heroui/react";
import Logo from "../assets/img/MASH-Primary-logo-White-cool.png";
import TextLogo from "../assets/img/MASH Primary logo White-aligned only text.svg";
import NewsTicker from "./news-ticker";

interface NavMenuProps {}

const NavMenu: React.FC<NavMenuProps> = () => {
  const navigate = useNavigate();
  const shouldShowNewsTicker = false;
  return (
    <>
      <header
        className={`absolute w-full left-0 top-0 z-50 px-4 md:pb-2 ${
          shouldShowNewsTicker ? "pb-1 md:pb-3 md:pt-1" : "md:pt-2"
        }`}
        style={{
          background: "#101017",
          boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
        }}
      >
        {shouldShowNewsTicker && <NewsTicker />}
        <nav
          className="max-w-screen-2xl mx-auto lg:rounded-b-lg"
          role="navigation"
          aria-label="Main navigation"
        >
          <div className="flex items-center">
            {/* Mash logo, clickable */}
            <button
              className="hidden md:flex items-center flex-shrink-0 cursor-pointer gap-2 -mt-2"
              onClick={() => navigate("/")}
              aria-label="Go to homepage"
            >
              <Image src={Logo} alt="mash.fun" height={32} radius="none" />
            </button>
            <button
              className="flex md:hidden items-center flex-shrink-0 cursor-pointer gap-2 mt-1"
              onClick={() => navigate("/")}
              aria-label="Go to homepage"
            >
              <Image src={TextLogo} alt="mash.fun" height={16} radius="none" />
            </button>
            {/* Spacer to push nav items to the right */}
          </div>
        </nav>
      </header>
    </>
  );
};

export default NavMenu;
